import type { TLanguage } from '../definitions'

import { LANGUAGES } from '../consts'

/**
 * A string megfelel a rendszerben található, kétbetűs régiókódnak (ISO 639-1)?
 * @param code - A kód, amit vizsgálunk.
 */
export default function isValidRegionCode (code: string): code is TLanguage {
  // @ts-expect-error Nem érdekel a ts figyelmeztetése.
  return LANGUAGES.includes(code)
}
